module.exports = __webpack_public_path__ + "static/media/Logo.cbacf102.png";